<mat-dialog-content>
  @if (message) {
    <p> {{message}} </p>
  }

  @if (type !== 'hint') {
    <form [formGroup]="eventForm" class="form">
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (type !== 'hint') {
    <button mat-raised-button mat-dialog-close> Cancel </button>
  }
  @if (type === 'switch' || type === 'hint') {
    <button mat-raised-button (click)="onConfirmClick()"> Confirm </button>
  }
  @if (type === 'confirm') {
    <button mat-raised-button color="primary" [mat-dialog-close]="eventForm.getRawValue()"> Confirm </button>
  }
</mat-dialog-actions>

